import { z } from "zod";

export const zenDeskSectionSchema = z.object({
	id: z.number(),
	zenDeskId: z.number(),
	categoryId: z.number(),
	name: z.string(),
	description: z.string(),
	parentSectionId: z.number().nullable(),
});

export const zenDeskSectionsSchema = z.array(zenDeskSectionSchema);